import {INPUT_TYPE} from '../IdfSaleEnums';

export const validateForm = (formData, fields) => {
  const errors = {};

  fields.forEach((field) => {
    const {value, type} = formData[field];

    switch (type) {
      case INPUT_TYPE.PHONE:
        errors[field] = !validateInput(value, type);
        break;
      case INPUT_TYPE.EMAIL:
        errors[field] = !validateInput(value, type);
        break;
      case INPUT_TYPE.POSTAL_CODE:
        errors[field] = !validateInput(value, type);
        break;
      case INPUT_TYPE.ID:
        errors[field] = !validateInput(value, type);
        break;
      case INPUT_TYPE.TEXT_FIELD:
        errors[field] = !value;
        break;
      case INPUT_TYPE.NUMBER_FIELD:
        errors[field] = !value;
        break;

      default:
        errors[field] = !value;
    }
  });

  return errors;
};

export const validateInput = (input, validationType) => {
  let regexPattern;
  switch (validationType) {
    case INPUT_TYPE.EMAIL:
      regexPattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      break;
    case INPUT_TYPE.PHONE:
      regexPattern = /^0((5\d{1})|([2-4,8-9]\d{0,1}))-?\d{7}$/;
      break;
    case INPUT_TYPE.POSTAL_CODE:
      regexPattern = /^\d{7}$/;
      break;
    case INPUT_TYPE.ID:
      regexPattern = /^[0-9]{9}$/; // 9 digits
      break;
    case INPUT_TYPE.TEXT_FIELD:
      regexPattern = /^[a-zA-Zא-ת\s]*$/;
      break;
    case INPUT_TYPE.NUMBER_FIELD:
      regexPattern = /^[0-9]*$/;
      break;
    default:
      throw new Error('Invalid validation type');
  }

  const isValid = regexPattern.test(String(input).toLowerCase());
  return isValid;
};
